"use client";

import { Container } from "@/components/primitives/Container";
import { Eyebrow } from "@/components/primitives/Eyebrow";
import { Reveal } from "@/components/motion/Reveal";
import { PartnerForm } from "@/components/forms/PartnerForm";
import { getPartners } from "@/content/partners";
import { useLocale } from "@/lib/i18n/provider";

export function PartnerApplication() {
  const { locale } = useLocale();
  const copy = getPartners(locale);

  return (
    <section id="apply" className="relative overflow-hidden py-24 md:py-36">
      {/* Centre glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full blur-[150px]"
        style={{
          background:
            "radial-gradient(50% 50% at 50% 50%, rgba(var(--glow-accent-rgb), 0.22) 0%, rgba(var(--glow-accent-rgb), 0) 70%)",
        }}
      />

      <Container>
        <div className="grid gap-16 lg:grid-cols-[1fr_1.4fr] lg:gap-24">
          {/* Left: context copy */}
          <div className="lg:pt-2">
            <Reveal delay={0}>
              <Eyebrow>{copy.application.eyebrow}</Eyebrow>
            </Reveal>
            <Reveal delay={0.07}>
              <h2 className="mt-5 text-[clamp(2rem,4vw,3rem)] font-bold leading-[1.06] tracking-[-0.025em] text-[var(--color-text-primary)]">
                {copy.application.title}
              </h2>
            </Reveal>
            <Reveal delay={0.14}>
              <p className="mt-5 text-[clamp(1rem,1.2vw,1.1rem)] leading-relaxed text-[var(--color-text-secondary)]">
                {copy.application.body}
              </p>
            </Reveal>

            {/* Trust signals */}
            <Reveal delay={0.2}>
              <ul className="mt-10 flex flex-col gap-4">
                {copy.application.trustItems.map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-3 text-sm text-[var(--color-text-secondary)]"
                  >
                    <span
                      className="inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--color-accent-base)]"
                      aria-hidden="true"
                    />
                    {item}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          {/* Right: form card */}
          <Reveal delay={0.1}>
            <div className="rounded-3xl border border-[var(--color-surface-border)] bg-[var(--color-surface-glass)] p-8 md:p-10">
              <PartnerForm />
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}

export default PartnerApplication;
